import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 0.5rem;
  display: flex;
  gap: 8px;
  margin-top: 1rem;
`;

export const Text = styled.p`
  font-size: 0.75rem;
`;
